import { Backdrop as MuiBackdrop, backdropClasses, css, styled } from '@mui/material';

import type { BlanketProps } from './types';

const Blanket = (props: BlanketProps) => {
  return <BlanketRoot {...props} />;
};

const BlanketRoot = styled(MuiBackdrop)(
  ({ theme }) => css`
    background-color: ${theme.color['background/blanket']};

    &.${backdropClasses.invisible} {
      background-color: transparent;
    }
  `,
);

export default Blanket;
